import Vue from 'vue'

import moment from 'moment'
import VueMomentJS from 'vue-momentjs'

Vue.use(VueMomentJS, moment)



// WEBPACK FOOTER //
// ./src/plugins/moment.js